import React from 'react';
import cn from 'classnames';

import { Star, Package } from '@crehana/icons/dist/outline';
import { primaryMain } from '@crehana/ui/dist/styles/colors';

interface ButtonLinkIconProps {
  label: string;
  iconType: 'star' | 'package';
  noMarginBottom?: boolean;
  href: string;
  blank?: boolean;
}

const ButtonLinkIcon: React.FC<ButtonLinkIconProps> = ({
  label,
  iconType,
  noMarginBottom,
  href,
  blank,
}) => {
  return (
    // eslint-disable-next-line react/jsx-no-target-blank
    <a
      href={href}
      target={blank ? '_blank' : undefined}
      className={cn(
        'flex items-center transition-all duration-500 ease-in-out text-base-main hover:text-primary-main cursor-pointer tw-font-semibold',
        { 'mb-16': !noMarginBottom },
      )}
      rel={blank ? 'noopener noreferrer' : ''}
    >
      <span className="mr-8">{label}</span>
      {iconType === 'star' && (
        <Star
          ignoreColor
          className="fill-current text-primary-main min-w-16"
          size={16}
          aria-hidden
        />
      )}
      {iconType === 'package' && (
        // NOTE: It's necessary pass color prop to render SVG stroke line colors
        <Package
          color={primaryMain}
          className="min-w-16"
          size={16}
          aria-hidden
        />
      )}
    </a>
  );
};

export default ButtonLinkIcon;
